export default __webpack_public_path__ + "static/media/ic_ethiopia.ab24a205.svg";